import { useStorageService } from "@/services/storage-service";

export const fourHoursInSeconds = 4 * 60 * 60; // 4 hours in seconds

export function isLastActiveOlderThan4Hours(): boolean {
  const storageService = useStorageService();
  const lastActive = storageService.getLastActive();

  const lastActiveAsNumber = Number(lastActive);

  if (lastActive === null || isNaN(lastActiveAsNumber) || lastActiveAsNumber === 0) {
    return false;
  }
  const currentTime = new Date().getTime();

  return currentTime - Number(lastActive) > fourHoursInSeconds * 1000;
}

export function isSessionOlderThan8Hours(): boolean {
  const storageService = useStorageService();
  const firstSignIn = storageService.getFirstSignIn();

  const firstSignInAsNumber = Number(firstSignIn);

  if (firstSignIn === null || isNaN(firstSignInAsNumber) || firstSignInAsNumber === 0) {
    return false;
  }
  const currentTime = new Date().getTime();

  return currentTime - Number(firstSignIn) > 2 * fourHoursInSeconds * 1000;
}

